import { gender } from "keys"

const constants = {
    title: "ברוכים הבאים למערכת המבדקים",
    you: {
        [gender.male]: "לך",
        [gender.female]: "לך"
    },
    you2: {
        [gender.male]: "אותך",
        [gender.female]: "אותך"
    }
}

export default constants